module.exports = __webpack_public_path__ + "static/media/recommend2.16336aba.png";